import { render, staticRenderFns } from "./VideoOverlay.vue?vue&type=template&id=cb4931c2"
import script from "./VideoOverlay.vue?vue&type=script&lang=js"
export * from "./VideoOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports